var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.contactUsBannerStyle)},[(_vm.lang)?_c('img',{attrs:{"src":'/img/kontakt_' + _vm.lang + '.jpg'}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }